import { render, staticRenderFns } from "./kisitip.vue?vue&type=template&id=678e4bda&"
import script from "./kisitip.vue?vue&type=script&lang=js&"
export * from "./kisitip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports